var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.333252 16.9987C0.333252 12.5784 2.0892 8.33919 5.21481 5.21358C8.34041 2.08798 12.5796 0.332031 16.9999 0.332031C19.1886 0.332031 21.3559 0.763127 23.378 1.60071C25.4001 2.43828 27.2374 3.66594 28.785 5.21358C30.3327 6.76123 31.5603 8.59855 32.3979 10.6206C33.2355 12.6427 33.6666 14.81 33.6666 16.9987C33.6666 21.419 31.9106 25.6582 28.785 28.7838C25.6594 31.9094 21.4202 33.6654 16.9999 33.6654C14.8112 33.6654 12.644 33.2343 10.6219 32.3967C8.59977 31.5591 6.76245 30.3315 5.21481 28.7838C2.0892 25.6582 0.333252 21.419 0.333252 16.9987ZM13.6666 25.332L21.9999 16.9987L13.6666 8.66536V25.332Z",
    fill: "#374DA0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayRight);
export default __webpack_public_path__ + "static/media/playRight.bee09c92078b18b07c351bb510c994b3.svg";
export { ForwardRef as ReactComponent };